module.exports = __webpack_public_path__ + "img/169.93c89417.jpg";